import { Outlet } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'
import { WikiNavProvider } from './wikiNavContext'

export default function Layout() {
  return (
    <WikiNavProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex flex-col lg:flex-row w-full max-w-[1800px] mx-auto px-4 pt-[var(--wiki-sticky-gap)] pb-4 gap-4 sm:px-6">
          <Sidebar />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
        <Footer />
      </div>
    </WikiNavProvider>
  )
}
